var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"antialiased flex flex-col",attrs:{"id":"app"}},[_c('div',{staticClass:"min-h-screen bg-gray-100 flex flex-col"},[_c('Header'),_c('router-view',{staticClass:"flex-grow"}),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }